import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { history } from '../../helpers/history'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Content from './components/content/content.component'
import { Container } from './styles.style'
import { toastActions, userActions } from '../../actions'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { routes } from '../../constants/routes.constants'

const SocialLoginRegisterPage = props => {
	const { user, toastError, toastSuccess, hideLoading, showLoading, providerSignupData, userLogin } = props
	if (!providerSignupData)
		history.push(routes.CADASTRO)

	return (
		<Fragment>
			<Container logged={user}>
				<Content
					userLogin={userLogin}
					toastError={toastError}
					hideLoading={hideLoading}
					showLoading={showLoading}
					toastSuccess={toastSuccess}
					providerSignupData={providerSignupData}
				/>
			</Container>
		</Fragment>
	)
}

const mapStateToProps = store => ({
	user: store.user,
	providerSignupData: store.authentication.providerSignupData
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			userLogin: user => dispatch(userActions.login(user))

		},
		dispatch
	)

const connectedSocialLoginRegisterPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SocialLoginRegisterPage)
)
export { connectedSocialLoginRegisterPage as ModuleRootComponent }
